import type { App } from 'vue'
import { LotoIcon, XcaiSvgIcon, LotoLeft } from './icons'
import { Toast } from 'vant'
import { NAvatar } from 'naive-ui'

export function installUiWidgets(app: App) {
  app.component('loto-icon', LotoIcon)
  app.component('loto-left', LotoLeft)
  app.component('xcai-svg-icon', XcaiSvgIcon)

  app.component('n-avatar', NAvatar)

  // vant
  app.use(Toast)
}
